import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';

var useSkipLinks = function useSkipLinks() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      mainContentNode = _useState2[0],
      mainContentRef = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      mainNavNode = _useState4[0],
      mainNavRef = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      subNavNode = _useState6[0],
      subNavRef = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      footerNode = _useState8[0],
      footerRef = _useState8[1];

  return {
    mainContentNode: mainContentNode,
    mainNavNode: mainNavNode,
    subNavNode: subNavNode,
    footerNode: footerNode,
    mainContentRef: mainContentRef,
    mainNavRef: mainNavRef,
    subNavRef: subNavRef,
    footerRef: footerRef
  };
};

var useSkipLinks$1 = useSkipLinks;

export { useSkipLinks$1 as default };
